import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Card from "../../components/Card/Card";
import "./TechStackPage.css";

// Importing assets
import FigmaIcon from "../../assets/figmaIcon.png";
import GithubIcon from "../../assets/Github.png";
import VsCodeIcon from "../../assets/VsCode.png";
import TypeScript from "../../assets/TypeScript.png";
import ReactQuery from "../../assets/ReactQuery.png";
import Abp from "../../assets/abp.png";
import PgAdmin from "../../assets/pgadmin4.png";
import VisualStudio from "../../assets/visualstudio.png";
import Csharp from "../../assets/csharp.png";
import Javascript from "../../assets/javascript.png";

const TechStackPage: React.FC = () => {
  const darkMode = useSelector((state: RootState) => state.theme.darkMode);
  return (
    <div
      className={`tech-stack-container ${darkMode ? "dark" : "light"}`}
      data-theme={darkMode ? "dark" : "light"}
    >
      <div className="background-top" />
      <div className="background-bottom" />
      <Navbar />
      <main className="tech-stack-main-section">
        <div className="techstack-content">
          <h1>Tech Stack</h1>
          <p>The dev tools and devices I use.</p>
        </div>
        <div className="separator"></div>

        <div className="tech-cards-container">
          <section className="tech-cards">
            <h2>Dev & Design</h2>
            <div className="cards-grid-tsp">
              <Card
                imageUrl={VsCodeIcon}
                title="VS Code"
                description="Editor"
              />
              <Card
                imageUrl={VisualStudio}
                title="Visual Studio"
                description="IDE"
              />
              <Card
                imageUrl={Csharp}
                title="C#"
                description="Language"
              />
              <Card imageUrl={Abp} title="ABP" description="Framework" />
              <Card imageUrl={FigmaIcon} title="Figma" description="Design" />
              <Card
                imageUrl={GithubIcon}
                title="Github"
                description="Version Control"
              />
              <Card
                imageUrl={TypeScript}
                title="TypeScript"
                description="Language"
              />
              <Card
                imageUrl={ReactQuery}
                title="React Query"
                description="Server State "
              />
              <Card imageUrl={PgAdmin} title="pgAdmin 4" description="Database" />
              <Card
                imageUrl={Javascript}
                title="JavaScript"
                description="Language"
              />
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TechStackPage;
